<template>
  <Layout>
    <app-socios-cards />
  </Layout>
</template>

<script>
import SocioUsuarioInfo from "../components/SocioUsuarioInfo/SocioUsuarioInfo.vue";

export default {
  components: {
    "app-socios-cards": SocioUsuarioInfo
  }
};
</script>
